module.exports = __webpack_public_path__ + "img/dropdown-arrow.822c946d.svg";